import { ProfileLayout } from "@features/profile";

export const ProfilePage = () => {
  return <ProfileLayout />;
};
